import React from 'react';
import { Link } from 'react-router-dom';
import { Trans } from 'react-i18next';
import Logo from '../Logo';

const Footer = () => {
    return (
        <footer className="bg-white border-t border-gray-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-4">
                <div className="text-center text-gray-500">
                    <p><Trans
                        i18nKey="common.footer"
                        components={{ logo: <Logo inline fontSize={24} /> }}
                        values={{ year: new Date().getFullYear() }}
                    /></p>
                </div>
                <nav className="flex items-center justify-center gap-4 text-sm">
                    <Link to="/privacy" className="text-gray-500 hover:text-gray-700">
                        <Trans i18nKey="legal.footerLinks.privacy" />
                    </Link>
                    <span className="text-gray-300">•</span>
                    <Link to="/cookies" className="text-gray-500 hover:text-gray-700">
                        <Trans i18nKey="legal.footerLinks.cookies" />
                    </Link>
                </nav>
            </div>
        </footer>
    );
};

export default Footer;


